import { StayCycle } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const stayCycleLabel: Record<StayCycle, string> = {
  [StayCycle.preStay]: 'Pre-Stay',
  [StayCycle.inStay]: 'In-Stay',
  [StayCycle.postStay]: 'Post-Stay',
}
